/* globals $ */
import { registerClass } from 'libs/ComponentLoader'
import { formatMoney, formatImageUrl } from '_global/js/helpers'
import { getCustomerDiscount } from 'libs/DisplayDiscount'
import MicroModal from 'micromodal'

import './styles.scss'

class CartModal {
  constructor (element) {
    this.$el = $(element)

    // Setup Modal
    MicroModal.init()
  }

  openModal (data) {
    const { productData, cartData, formData } = data

    const { // from addToCart API
      price: productPrice,
      title: productTitle,
      sku: productSku,
      image: productImage,
      properties: productProperties
    } = productData

    const { // from Cart API
      item_count: totalItems,
      items_subtotal_price: subtotal
    } = cartData

    const { // from add to cart form
      quantity
    } = formData

    // see if the product has instalments / subscriptions
    let priceAddendum = ''
    if (productProperties) {
      if (productProperties.hasOwnProperty('instalment_payments')) {
        priceAddendum = ` x ${productProperties.instalment_payments}`
      } else if (productProperties.hasOwnProperty('shipping_interval_unit_type') && productProperties.hasOwnProperty('shipping_interval_frequency')) {
        if (parseInt(productProperties.shipping_interval_frequency) === 1) {
          const singularInterval = productProperties.shipping_interval_unit_type.slice(0, -1)
          priceAddendum = `<br>per ${singularInterval}`
        } else {
          priceAddendum = `<br>per ${productProperties.shipping_interval_frequency} ${productProperties.shipping_interval_unit_type}`
        }
      }
    }

    const productDiscount = getCustomerDiscount(window.product)
    const currentPrice = (productDiscount !== false) ? productDiscount.finalPrice : productPrice

    // Update Product Info
    this.$el.find('.cartModal-productTitle').text(productTitle)
    this.$el.find('.cartModal-productPrice').html(`${formatMoney(currentPrice)}${priceAddendum}`)
    this.$el.find('.cartModal-productSku span').text(productSku)
    this.$el.find('.cartModal-option--qty span').text(quantity)

    if (productImage) {
      const $sourceTag = $('<source srcset="" sizes="150" />')
      const imageSrcs = [
        formatImageUrl(productImage, 'x118'),
        formatImageUrl(productImage, 'x91')
      ]

      $sourceTag.attr('srcset', imageSrcs.join(','))
      this.$el.find('.cartModal-imageContainer').prepend($sourceTag)
    }

    // Cart Summary
    this.$el.find('.cartModal-count').text(totalItems)
    this.$el.find('.cartModal-subtotalPrice').html(formatMoney(subtotal))

    MicroModal.show('addToCart-modal', {
      disableScroll: true
    })
  }
}

registerClass('CartModal', CartModal)
